import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import OrderSummary from '../order-summary/OrderSummary';

const SectionDiv = styled(Box)({
  flexDirection: 'column',
  width: '100%',
});

const ConfirmAndSubmit = ({
  affiliateOptions,
  affiliates,
  currentAffiliate,
  currentLocation,
  currentProduct,
  chainContactIds,
  data,
  originatorLocationProductOrigins,
}) => {
  const modifiedContactIds = [];
  if (chainContactIds) {
    chainContactIds.forEach(id => {
      const chainContact = affiliateOptions.find(({ value }) => value === id.toString());
      const name = chainContact.label;
      modifiedContactIds.push({ id, name });
    });
  }
  return (
    <SectionDiv display="flex">
      <OrderSummary
        chainContactIds={modifiedContactIds}
        createPtoData={data}
        currentAffiliate={currentAffiliate}
        currentLocation={currentLocation}
        currentProduct={currentProduct}
        detailsExpanded
        headerButton={false}
        headerTitle="Review Your New Product Transfer Order"
        originatorLocationProductOrigins={originatorLocationProductOrigins}
        userAffiliates={affiliates}
      />
    </SectionDiv>
  );
};

ConfirmAndSubmit.propTypes = {
  affiliateOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  affiliates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  chainContactIds: PropTypes.arrayOf(PropTypes.number),
  currentAffiliate: PropTypes.shape({}),
  currentLocation: PropTypes.shape({}),
  currentProduct: PropTypes.shape({}),
  data: PropTypes.shape({}).isRequired,
  originatorLocationProductOrigins: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

ConfirmAndSubmit.defaultProps = {
  chainContactIds: [],
  currentAffiliate: {},
  currentLocation: {},
  currentProduct: {},
};

export default ConfirmAndSubmit;
